<template>
<div>
  <h2>学号：{{ sno }}</h2>
  <h2>姓名：{{ students.find(item => item.sno === Number(sno)).sname }}</h2>
  <h2>年龄：{{ students.find(item => item.sno === Number(sno)).age }}</h2>
</div>
</template>

<script>
import {mapState} from 'vuex'
export default {
  name: 'Detail',
  props: ['sno'],
  computed: {
    ...mapState(['students'])
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/Detail.vue